import React, { useState } from "react";

import { DatePicker } from "jalali-react-datepicker";
import moment from "moment-jalaali";
import { NotificationManager } from "react-notifications";
import { useDispatch, useSelector } from "react-redux";

import { routesActions, eventsActions, speedometerActions, applicationsActions } from "../../store";

import { map } from "../map";

import styles from "../../../styles/search.module.css";
import Spinner from "../../spinner";
import Conf from "../../../conf";

const Search = () => {
    const [startDate, setStartDate] = useState(moment().add(-1, "day"));
    const [endDate, setEndDate] = useState(moment());
    const [wait, set_wait] = useState(false);

    const dispatch = useDispatch();

    const [devices, selectedId] = useSelector((state) => {
        return [state.devices.items, state.devices.selectedId];
    });

    let selectedDevice = (selectedId && devices[selectedId]) || null;

    const getRoute = () => {
        if (selectedDevice) {
            set_wait(true);
            fetch(`${Conf.server_address}/positions?deviceId=${selectedDevice.id}&from=${startDate.toISOString()}&to=${endDate.toISOString()}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", accept: "application/json" },
                credentials: "include",
                cache: "no-cache",
            })
                .then((routes) => {
                    return routes.json();
                })
                .then((routes) => {
                    if (Object.keys(routes).length !== 0) {
                        new Promise(() => dispatch(routesActions.addPositions(routes)));
                        new Promise(() => dispatch(speedometerActions.update(undefined)));

                        new Promise(() => map.flyTo({ center: [routes[0].longitude, routes[0].latitude], zoom: 14 }));
                        new Promise(() => dispatch(applicationsActions.dialog(undefined)));

                        new Promise(() => dispatch(applicationsActions.haveRoute(true)));
                        set_wait(false);
                    } else {
                        set_wait(false);
                        NotificationManager.info("در این بازه زمانی موقعیتی ثبت نشده است", "", 2500);
                    }
                });
            fetch(`${Conf.server_address}/reports/stops?deviceId=${selectedDevice.id}&from=${startDate.toISOString()}&to=${endDate.toISOString()}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", accept: "application/json" },
                credentials: "include",
                cache: "no-cache",
            })
                .then((stopsEvents) => {
                    return stopsEvents.json();
                })
                .then((stopsEvents) => {
                    new Promise(() => dispatch(eventsActions.addEvents(stopsEvents)));
                    set_wait(false);
                });
        } else {
            set_wait(false);
            NotificationManager.warning("لطفا دستگاهی را انتخاب کنید", "", 2500);
        }
    };

    return (
        <div className={styles.main}>
            <div className={styles.div}>
                <div className={styles.text2}>جست و جو</div>
            </div>

            <div className={styles.div}>
                <div className={styles.text}>زمان شروع</div>
                <div className={styles.text1}>
                    <DatePicker
                        className={styles.DatePicker}
                        value={startDate}
                        open={true}
                        onClickSubmitButton={(startDate) => {
                            startDate = startDate.value;
                            setStartDate(startDate);
                        }}
                    />
                </div>
            </div>

            <div className={styles.div}>
                <div className={styles.text}>زمان پایان</div>
                <div className={styles.text1}>
                    <DatePicker
                        className={styles.DatePicker}
                        value={endDate}
                        onClickSubmitButton={(endDate) => {
                            endDate = endDate.value;
                            setEndDate(endDate);
                        }}
                    />
                </div>
            </div>

            <div className={styles.div}>
                <div id="search" className={styles.search} onClick={() => !wait && getRoute()}>
                    <Spinner wait={wait} center={true} height={18}>
                        نمایش
                    </Spinner>
                </div>
            </div>
        </div>
    );
};

export default Search;
